/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
    path => router path
    name => router name
    component(lazy loading) => component to load
    meta : {
      rule => which user can have access (ACL)
      breadcrumb => Add breadcrumb to specific page
      pageTitle => Display title besides breadcrumb
    }
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // 仪表盘
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard'
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/general/dashboard.vue'),
          meta: {
            title: '仪表盘'
          }
        },

        {
          path: '/notification/list',
          name: 'notificationList',
          component: () => import('./views/notification/list.vue'),
          meta: {
            title: '风控通知'
          }
        },

        // =============================================================================
        // 设置
        // =============================================================================
        {
          path: '/setting/base',
          name: 'settingBase',
          component: () => import('./views/setting/base.vue'),
          meta: {
            title: '基础设置',
            pageTitle: '基础设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '基础设置', active: true }
            ],
          }
        },
        {
          path: '/setting/notification',
          name: 'settingNotification',
          component: () => import('./views/setting/notification.vue'),
          meta: {
            title: '风控设置',
            pageTitle: '风控设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '风控设置', active: true }
            ],
          }
        },
        {
          path: '/setting/ng',
          name: 'settingNg',
          component: () => import('./views/setting/ng.vue'),
          meta: {
            title: 'NG设置',
            pageTitle: 'NG设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: 'NG设置', active: true }
            ],
          }
        },
        {
          path: '/setting/activity',
          name: 'settingActivity',
          component: () => import('./views/setting/activity.vue'),
          meta: {
            title: '活动设置',
            pageTitle: '活动设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '活动设置', active: true }
            ],
          }
        },
		{
		  path: '/setting/appupdate',
		  name: 'settingAppupdate',
		  component: () => import('./views/setting/appupdate.vue'),
		  meta: {
			title: 'APP更新',
			pageTitle: 'APP更新',
			breadcrumb: [
			  { title: '仪表盘', url: '/' },
			  { title: '程序设置' },
			  { title: 'APP更新', active: true }
			],
		  }
		},
        {
          path: '/setting/speed',
          name: 'settingSpeed',
          component: () => import('./views/setting/speed.vue'),
          meta: {
            title: '线路设置',
            pageTitle: '线路设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '线路设置', active: true }
            ],
          }
        },
        {
          path: '/setting/slide',
          name: 'settingSlide',
          component: () => import('./views/setting/slide.vue'),
          meta: {
            title: '轮播图设置',
            pageTitle: '轮播图设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '轮播图设置', active: true }
            ],
          }
        },
        {
          path: '/setting/virtual',
          name: 'settingVirtual',
          component: () => import('./views/setting/virtual.vue'),
          meta: {
            title: '虚拟币设置',
            pageTitle: '虚拟币设置',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '程序设置' },
              { title: '虚拟币设置', active: true }
            ],
          }
        },

        {
          path: '/admin/list',
          name: 'adminList',
          component: () => import('./views/admin/list.vue'),
          meta: {
            title: '管理员列表',
            pageTitle: '管理员列表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '管理员管理' },
              { title: '管理员列表', active: true }
            ],
          }
        },

        {
          path: '/user/list',
          name: 'userList',
          component: () => import('./views/user/list.vue'),
          meta: {
            title: '会员列表',
            pageTitle: '会员列表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '会员管理' },
              { title: '会员列表', active: true }
            ],
          }
        },
        {
          path: '/user/group',
          name: 'userGroup',
          component: () => import('./views/user/group.vue'),
          meta: {
            title: '会员用户组',
            pageTitle: '会员用户组',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '会员管理' },
              { title: '会员用户组', active: true }
            ],
          }
        },
        {
          path: '/user/bank',
          name: 'userBank',
          component: () => import('./views/user/bank.vue'),
          meta: {
            title: '会员银行卡',
            pageTitle: '会员银行卡',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '会员管理' },
              { title: '会员银行卡', active: true }
            ],
          }
        },
        {
          path: '/user/link',
          name: 'userLink',
          component: () => import('./views/user/link.vue'),
          meta: {
            title: '会员推广链接',
            pageTitle: '会员推广链接',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '会员管理' },
              { title: '会员推广链接', active: true }
            ],
          }
        },

        {
          path: '/money/receive',
          name: 'moneyReceive',
          component: () => import('./views/money/receive.vue'),
          meta: {
            title: '收款银行',
            pageTitle: '收款银行',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '资金管理' },
              { title: '收款银行', active: true }
            ],
          }
        },
        {
          path: '/money/send',
          name: 'moneySend',
          component: () => import('./views/money/send.vue'),
          meta: {
            title: '提款银行',
            pageTitle: '提款银行',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '资金管理' },
              { title: '提款银行', active: true }
            ],
          }
        },
        {
          path: '/money/pay',
          name: 'moneyPay',
          component: () => import('./views/money/pay.vue'),
          meta: {
            title: '第三方支付',
            pageTitle: '第三方支付',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '资金管理' },
              { title: '第三方支付', active: true }
            ],
          }
        },

        {
          path: '/lottery/list',
          name: 'lotteryList',
          component: () => import('./views/lottery/list.vue'),
          meta: {
            title: '彩种管理',
            pageTitle: '彩种管理',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '彩种管理', active: true }
            ],
          }
        },
        {
          path: '/lottery/played',
          name: 'lotteryPlayed',
          component: () => import('./views/lottery/played.vue'),
          meta: {
            title: '玩法管理',
            pageTitle: '玩法管理',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '玩法管理', active: true }
            ],
          }
        },
        {
          path: '/lottery/time',
          name: 'lotteryTime',
          component: () => import('./views/lottery/time.vue'),
          meta: {
            title: '时间管理',
            pageTitle: '时间管理',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '时间管理', active: true }
            ],
          }
        },
        {
          path: '/lottery/timeLhc',
          name: 'lotteryTimeLhc',
          component: () => import('./views/lottery/timeLhc.vue'),
          meta: {
            title: '时间管理 (六合彩)',
            pageTitle: '时间管理 (六合彩)',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '时间管理 (六合彩)', active: true }
            ],
          }
        },
        {
          path: '/lottery/data',
          name: 'lotteryData',
          component: () => import('./views/lottery/data.vue'),
          meta: {
            title: '开奖数据',
            pageTitle: '开奖数据',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '开奖数据', active: true }
            ],
          }
        },
        {
          path: '/lottery/plan',
          name: 'lotteryPlan',
          component: () => import('./views/lottery/plan.vue'),
          meta: {
            title: '计划管理',
            pageTitle: '计划管理',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '彩票管理' },
              { title: '开奖数据', active: true }
            ],
          }
        },

        {
          path: '/record/lottery',
          name: 'recordLottery',
          component: () => import('./views/record/lottery.vue'),
          meta: {
            title: '彩票注单',
            pageTitle: '彩票注单',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '注单记录' },
              { title: '彩票注单', active: true }
            ],
          }
        },
        {
          path: '/record/game',
          name: 'recordGame',
          component: () => import('./views/record/game.vue'),
          meta: {
            title: '游戏注单',
            pageTitle: '游戏注单',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '注单记录' },
              { title: '游戏注单', active: true }
            ],
          }
        },
        {
          path: '/record/cash',
          name: 'recordCash',
          component: () => import('./views/record/cash.vue'),
          meta: {
            title: '提现记录',
            pageTitle: '提现记录',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '注单记录' },
              { title: '提现记录', active: true }
            ],
          }
        },
        {
          path: '/record/recharge',
          name: 'recordRecharge',
          component: () => import('./views/record/recharge.vue'),
          meta: {
            title: '充值记录',
            pageTitle: '充值记录',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '注单记录' },
              { title: '充值记录', active: true }
            ],
          }
        },
        {
          path: '/record/user',
          name: 'recordUser',
          component: () => import('./views/record/userLog.vue'),
          meta: {
            title: '会员日志',
            pageTitle: '会员日志',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '日志记录' },
              { title: '会员日志', active: true }
            ],
          }
        },
        {
          path: '/record/admin',
          name: 'recordAdmin',
          component: () => import('./views/record/adminLog.vue'),
          meta: {
            title: '管理员日志',
            pageTitle: '管理员日志',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '日志记录' },
              { title: '管理员日志', active: true }
            ],
          }
        },
        {
          path: '/record/activity',
          name: 'recordActivity',
          component: () => import('./views/record/activityLog.vue'),
          meta: {
            title: '活动日志',
            pageTitle: '活动日志',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '日志记录' },
              { title: '活动日志', active: true }
            ],
          }
        },
        {
          path: '/report/user',
          name: 'reportUser',
          component: () => import('./views/report/user.vue'),
          meta: {
            title: '会员报表',
            pageTitle: '会员报表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '报表概览' },
              { title: '会员报表', active: true }
            ],
          }
        },
        {
          path: '/report/lottery',
          name: 'reportLottery',
          component: () => import('./views/report/lottery.vue'),
          meta: {
            title: '彩票报表',
            pageTitle: '彩票报表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '报表概览' },
              { title: '彩票报表', active: true }
            ],
          }
        },
        {
          path: '/report/game',
          name: 'reportGame',
          component: () => import('./views/report/game.vue'),
          meta: {
            title: '游戏报表',
            pageTitle: '游戏报表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '报表概览' },
              { title: '游戏报表', active: true }
            ],
          }
        },
        {
          path: '/report/team',
          name: 'reportTeam',
          component: () => import('./views/report/team.vue'),
          meta: {
            title: '团队报表',
            pageTitle: '团队报表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '报表概览' },
              { title: '团队报表', active: true }
            ],
          }
        },

        {
          path: '/article/list',
          name: 'articleList',
          component: () => import('./views/article/list.vue'),
          meta: {
            title: '文章列表',
            pageTitle: '文章列表',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '文章管理' },
              { title: '文章列表', active: true }
            ],
          }
        },

        {
          path: '/other/clean',
          name: 'otherClean',
          component: () => import('./views/other/clean.vue'),
          meta: {
            title: '数据清理',
            pageTitle: '数据清理',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '其他杂项' },
              { title: '数据清理', active: true }
            ],
          }
        },
        /*{
          path: '/other/update',
          name: 'otherUpdate',
          component: () => import('./views/other/update.vue'),
          meta: {
            title: '程序更新',
            pageTitle: '程序更新',
            breadcrumb: [
              { title: '仪表盘', url: '/' },
              { title: '其他杂项' },
              { title: '程序更新', active: true }
            ],
          }
        }*/
      ]
    },


    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [

        {
          path: '/pages/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/error404.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 天元'
  }
  next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none"
  }
})

export default router
